import { PublicOrderItemComponent } from './public-order-item-component';

export class PublicOrderItemComponentGroup {
  public constructor(
    private readonly data: {
      name: string;
      isRandomSelected: boolean;
      components: PublicOrderItemComponent[];
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get isRandomSelected(): boolean {
    return this.data.isRandomSelected;
  }

  public get components(): PublicOrderItemComponent[] {
    return this.data.components;
  }
}
